// The code in this file will load on every page of your site

$w.onReady(function () {
	//<script type='text/javascript' src='https://platform-api.sharethis.com/js/sharethis.js#property=610302e8b819bf0013917663&product=sop' async='async'></script>
});